/* convert someCamelCase to Some Camel Case.
 * This isn't perfect, it will convert someID to Some I D. But we can fix it later
 * if we come to a point where it isn't converting correctly.
 */
export const camelCaseToTitleCase = (string: string) =>
  string.replace(/^[a-z]|[A-Z]/g, (c, i) => (i ? " " : "") + c.toUpperCase());
